import { Maybe } from '../../../__generated__/globalTypes'

import {
  RelatedContactFragment,
  isRelatedContactFragment,
} from './RelatedContactFragment'

import childContactFragmentRawString from '../ChildContactFragment.graphql'

export const childContactFragmentString = childContactFragmentRawString

export type ChildContactFragment = RelatedContactFragment & {
  parent: Maybe<RelatedContactFragment>
}

export const isChildContactFragment = (
  fragment: any,
): fragment is ChildContactFragment =>
  (isRelatedContactFragment(fragment) as boolean) &&
  (fragment.parent === null ||
    (isRelatedContactFragment(fragment.parent) as boolean))
